// extracted by mini-css-extract-plugin
export default {"container":"SearchInput_container__kbPCI","input":"SearchInput_input__ZicFB","icon":"SearchInput_icon__eDO1m"};